module.exports = __webpack_public_path__ + "img/1.de19a084.png";